import React, {useEffect, useState} from "react";
import CustomTh from "../../../../components/table/CustomTh";
import CustomTd from "../../../../components/table/CustomTd";
import {status} from "../../../../enums/statusEnum";
import TableFunction from "../../../../components/table/TableFunction";
import ButtonSubAction from "../../../../components/buttons/ButtonSubAction";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../enums/statusColorEnum";
import CustomChip from "../../../../components/CustomChip";
import routes from "../../../../Routes/routes";
import {permissionObj} from "../../../../Helpers/permission";
import {useSelector} from "react-redux";
import {EMPTY_VALUES} from "../../../../Apis/functions";

/**
 * @Email: azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 *
 * @param data
 * @param search
 * @param setSelectedList
 * @constructor
 */

export const SingleZoneDetailsTableApp = ({
    data,
    selectedList,
    setSelectedList,
    setIsAllChecked,
    disabled,
    tableId,
    modified,
    setModified
}) =>{
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const deletePermission =  !disabled && (DEV || permission?.includes(permissionObj?.WEB_ZONE_DELETE))
    const leftPosition = deletePermission ? 50 : 0;
    const [results, setResults] = useState({ content: [], totalElements: 0 });


    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head">{t('sub_zone')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('access_devices')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('common_area')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('status')}</CustomTh>,
        ];
    }

    const getTbody = () => {
        if (!results || results?.length === 0 || results?.content?.length === 0)  return {
            body: [],
            data: []
        };

        let body = results?.content.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} tooltip={item?.name} fixed={true} left={leftPosition} classes={'first-column'}>
                        {item?.name}
                        <ButtonSubAction
                            id='btn_zcd_details'
                            name='more_details'
                            url={routes.zone.details + item?.id}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId} >
                        {item?.devices.length === 0 ? (
                            <i className='fa fa-times' aria-hidden='true'/>
                        ) : (
                            <i className='fa fa-check' aria-hidden='true'/>
                        )}
                    </CustomTd>
                    <CustomTd tableId={tableId} >
                        {item?.commonArea === null ? (
                            <i className='fa fa-times' aria-hidden='true'/>
                        ) : (
                            <i className='fa fa-check' aria-hidden='true'/>
                        )}
                    </CustomTd>
                    <CustomTd tableId={tableId} >
                        <CustomChip
                            background={statusColor[item?.status?.id]}
                            fontColor={statusFontColor[item?.status?.id]}
                            borderColor={statusBorderColor[item?.status?.id]}
                            legend={t(status[item?.status?.id]).toUpperCase() || EMPTY_VALUES.DEFAULT}
                        />

                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: results?.content
        }
    };

    const getActionsButtons = () => {
        return <>
        </>;
    }

    const {t, thead, tbody, handleCheckboxChange, handleDeleteAll, page, rowsPerPage,
        pagination} = TableFunction({
        fixedPagination:false,
        selectedList:selectedList,
        setSelectedList:setSelectedList,
        data:results,
        getThead,
        getTbody,
        labelRowsPerPage:"sub_zones_per_page",
        setIsAllChecked,
        modified,
        setModified
    });

    useEffect(() => {
        if (!data?.children) {
            return;
        }

        const start = page * rowsPerPage;
        const end = start + rowsPerPage;
        setResults({ content: data.children.slice(start, end), totalElements: data.children?.length })
    }, [data?.children, page, rowsPerPage]);

    return {
        DEV,
        permission,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        pagination,
        deletePermission
    };

}
